import { ProgressiveSearchModalKeys, SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';

export type BackNavigationResult
  = | { action: 'trigger-attention-animation' }
    | { action: 'jump'; key: ProgressiveSearchModalKeys; returning: boolean }
    | null;

export function resolveBackNavigation(
  currentKey: string,
  selectedProcedures: SelectedProcedures[],
  eventType: 'escape' | 'interact-outside',
): BackNavigationResult {
  if (currentKey === ProgressiveSearchModalKeys.ATTENTION_TO_LOSE_LABORATORY_PROCEDURE) {
    if (eventType === 'escape') {
      return { action: 'trigger-attention-animation' };
    }
    if (eventType === 'interact-outside' && selectedProcedures.length > 0) {
      return { action: 'trigger-attention-animation' };
    }
    return null;
  }

  if (eventType === 'interact-outside') {
    if (currentKey === ProgressiveSearchModalKeys.SELECTED_OVERVIEW_EXAMS) {
      return { action: 'jump', key: ProgressiveSearchModalKeys.ATTENTION_TO_LOSE_LABORATORY_PROCEDURE, returning: true };
    }
    return null;
  }

  if (currentKey === ProgressiveSearchModalKeys.SELECT_MORE_EXAMS) {
    if (selectedProcedures.length === 0) {
      return { action: 'jump', key: ProgressiveSearchModalKeys.SEARCH, returning: true };
    }
    return { action: 'jump', key: ProgressiveSearchModalKeys.ATTENTION_TO_LOSE_LABORATORY_PROCEDURE, returning: true };
  }

  if (
    currentKey === ProgressiveSearchModalKeys.SELECTED_OVERVIEW_EXAMS
    || currentKey === ProgressiveSearchModalKeys.ASK_ADD_MORE_EXAMS
  ) {
    if (selectedProcedures.length > 0) {
      return { action: 'jump', key: ProgressiveSearchModalKeys.ATTENTION_TO_LOSE_LABORATORY_PROCEDURE, returning: true };
    }
    return { action: 'jump', key: ProgressiveSearchModalKeys.SEARCH, returning: true };
  }

  return null;
}
